
import { Component, Prop, Vue } from 'vue-property-decorator'
import { isExternal } from '@/common/utils'

@Component({
    name: 'SidebarItemLink'
})
export default class extends Vue {
    @Prop({ required: true }) private to!: string

    private isExternal = isExternal
}
